import { subtitulo } from '@/constants/Dimens';
import TuneIcon from '@mui/icons-material/Tune';
import { useTranslation } from 'next-i18next';
import TituloSeccionH2 from '../elements/TituloSeccionH2';
import TextFieldCustom, { AutocompleteValues, InputTypes } from '../elements/TextFieldCustom';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Boton from '../elements/Boton';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    textoBuscar: string;
    setTextoBuscar: (textoBuscar: string) => void;
    onKeyDown?: () => void;
    onShowFilter?: () => void;
    placeHolder?: string;
    focus?: boolean;
}

function BarraBuscar({ textoBuscar, setTextoBuscar, onKeyDown, onShowFilter, placeHolder, focus = true }: Props) {

    const { t } = useTranslation();

    return (
        <section style={{ display: 'flex', flexDirection: 'column' }}>
            <TituloSeccionH2 fontSize={subtitulo} texto={t("contenido:buscar-libros-de-segunda-mano.busqueda")} />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <TextFieldCustom focus={focus} id="email" label={t('contenido:buscar-libros-de-segunda-mano.titulo_isb_autor')}
                    value={textoBuscar}
                    setValue={setTextoBuscar}
                    placeholder={placeHolder}
                    required={false} autocomplete={AutocompleteValues.Off} inputType={InputTypes.Search}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            if (onKeyDown) {
                                onKeyDown();
                            }
                        }
                    }
                    }
                    leftIcon={<MenuBookIcon />} />
                {onShowFilter && (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '10px', marginTop: '5px' }}>
                        <Boton startIcon={<TuneIcon />} texto={""} onClick={onShowFilter} isIconOnly />
                    </div>
                )}
            </div>
        </section>
    );
}

export default BarraBuscar;